module.exports = __webpack_public_path__ + "img/type10060.7cb83f6e.png";